/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */

import React, { PureComponent } from 'react';
import cn from 'classnames';
import { Translator } from 'ggApp/modules/translator/components';

import styles from './index.module.scss';

export default class FormsInputDoubled extends PureComponent {
    render() {
        const {
            labels,
            disabled,
            names,
            flexes,
            reqMark,
            globalError,
            ids = [],
            dark,
        } = this.props;

        return (
            <div
                className={cn(styles.formsInputDoubled, {
                    [styles['formsInputDoubled--disabled']]: disabled,
                    [styles['formsInputDoubled--dark']]: dark,
                })}
            >
                <div className={styles.formsInputDoubled__boxWrap}>
                    {names.map((field, index) => (
                        <div
                            key={index}
                            style={{
                                flex: flexes[index],
                            }}
                        >
                            <div
                                className={cn(styles.formsInputDoubled__box, {
                                    [styles['formsInputDoubled__box--error']]:
                                        (this.props[field].meta.touched &&
                                            !!this.props[field].meta.error) ||
                                        !!globalError,
                                    [styles['formsInputDoubled__box--valid']]: this.props[field]
                                        .meta.valid,
                                    [styles['formsInputDoubled__box--active']]:
                                        this.props[field].meta.active ||
                                        this.props[field].input.value.length !== 0,
                                })}
                            >
                                {labels[index] && (
                                    <div className={styles.formsInputDoubled__label}>
                                        <div>
                                            <Translator tk={labels[index]} /> {reqMark ? '*' : ''}
                                        </div>
                                    </div>
                                )}
                                <input
                                    {...this.props[field].input}
                                    id={ids[index]}
                                    autoComplete="off"
                                    type="text"
                                />
                            </div>
                            {this.props[field].meta.touched && !!this.props[field].meta.error && (
                                <div className={styles.formsInputDoubled__error}>
                                    <Translator tk={this.props[field].meta.error} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
